(function ($) {
  $.oneTurbolinksLoad = function (f) {
    if (document.documentElement.hasAttribute("data-turbolinks-preview"))
      return;
    $(document).one("turbolinks:load", f);
  };
})(jQuery);
